import * as Sentry from '@sentry/react'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

interface MyRouterContext {
	queryClient: QueryClient
}

function ErrorFallback() {
	const { t } = useTranslation()
	return (
		<div className='flex min-h-screen items-center justify-center p-4'>
			<p className='text-muted-foreground'>{t('error.boundary_fallback')}</p>
		</div>
	)
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
				<TooltipProvider>
					<Outlet />
				</TooltipProvider>
			</Sentry.ErrorBoundary>
			<Toaster />
		</>
	),
})
